// src/components/inventory/InventoryFilters.jsx - Fixed for auto search
import React, { useState } from "react";
import Input from "../common/Input";
import Button from "../common/Button";

const InventoryFilters = ({ filters, categories, brands, onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  // FIXED: Use filters.search directly instead of separate state
  const handleSearchChange = (e) => {
    onFilterChange("search", e.target.value);
  };

  // REMOVED: Search submit handler is no longer needed for auto search
  // Keep it for form submission but make it optional
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // Do nothing - search already happens on input change
  };

  // Handle filter change
  const handleFilterChange = (name) => (e) => {
    onFilterChange(name, e.target.value);
  };

  // Clear all filters
  const handleClearFilters = () => {
    onFilterChange("search", "");
    onFilterChange("category", "");
    onFilterChange("brand", "");
    onFilterChange("stockFilter", "all");
    onFilterChange("sortBy", "createdAt");
    onFilterChange("sortDirection", "desc");
    setIsOpen(false);
  };

  // Toggle filters panel
  const toggleFilters = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="bg-white shadow rounded-md p-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-2 sm:space-y-0">
        {/* Search Bar - FIXED for auto search */}
        <form onSubmit={handleSearchSubmit} className="w-full sm:w-96">
          <div className="relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <input
              type="text"
              className="block w-full pl-10 pr-20 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
              placeholder="Search products..."
              value={filters.search || ""}
              onChange={handleSearchChange}
            />
            {/* OPTIONAL: Keep search button but make it less prominent */}
            {filters.search && (
              <div className="absolute inset-y-0 right-0 flex items-center pr-2">
                <button
                  type="button"
                  className="text-gray-400 hover:text-gray-600"
                  onClick={() => onFilterChange("search", "")}
                  title="Clear search"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </form>

        {/* Toggle Filters Button */}
        <button
          type="button"
          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          onClick={toggleFilters}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
              clipRule="evenodd"
            />
          </svg>
          {isOpen ? "Hide Filters" : "Show Filters"}
        </button>
      </div>

      {/* Filters Panel */}
      {isOpen && (
        <div className="mt-4 border-t pt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Categories Filter */}
            <div>
              <label
                htmlFor="category"
                className="block text-sm font-medium text-gray-700"
              >
                Category
              </label>
              <select
                id="category"
                name="category"
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
                value={filters.category}
                onChange={handleFilterChange("category")}
              >
                <option value="">All Categories</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Brands Filter */}
            <div>
              <label
                htmlFor="brand"
                className="block text-sm font-medium text-gray-700"
              >
                Brand
              </label>
              <select
                id="brand"
                name="brand"
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
                value={filters.brand}
                onChange={handleFilterChange("brand")}
              >
                <option value="">All Brands</option>
                {brands.map((brand) => (
                  <option key={brand.id} value={brand.id}>
                    {brand.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Stock Filter */}
            <div>
              <label
                htmlFor="stockFilter"
                className="block text-sm font-medium text-gray-700"
              >
                Stock Status
              </label>
              <select
                id="stockFilter"
                name="stockFilter"
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
                value={filters.stockFilter}
                onChange={handleFilterChange("stockFilter")}
              >
                <option value="all">All Products</option>
                <option value="in-stock">In Stock</option>
                <option value="low-stock">Low Stock</option>
                <option value="out-of-stock">Out of Stock</option>
              </select>
            </div>

            {/* Sort By */}
            <div>
              <label
                htmlFor="sortBy"
                className="block text-sm font-medium text-gray-700"
              >
                Sort By
              </label>
              <select
                id="sortBy"
                name="sortBy"
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
                value={filters.sortBy}
                onChange={handleFilterChange("sortBy")}
              >
                <option value="createdAt">Date Added</option>
                <option value="name">Product Name</option>
                <option value="price">Price</option>
                <option value="stock">Stock</option>
                <option value="sales">Sales</option>
              </select>

              {/* Sort Direction Toggle */}
              <div className="mt-2 flex items-center">
                <button
                  type="button"
                  className={`px-2 py-1 rounded-l-md border ${
                    filters.sortDirection === "asc"
                      ? "bg-orange-50 border-orange-500 text-orange-700"
                      : "bg-white border-gray-300 text-gray-700"
                  }`}
                  onClick={() => onFilterChange("sortDirection", "asc")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  className={`px-2 py-1 rounded-r-md border-t border-b border-r ${
                    filters.sortDirection === "desc"
                      ? "bg-orange-50 border-orange-500 text-orange-700"
                      : "bg-white border-gray-300 text-gray-700"
                  }`}
                  onClick={() => onFilterChange("sortDirection", "desc")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Active Filters and Clear Button */}
          <div className="mt-4 flex items-center justify-between">
            <div className="flex flex-wrap gap-2">
              {filters.search && (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  Search: {filters.search}
                  <button
                    type="button"
                    className="ml-1 text-orange-400 hover:text-orange-600"
                    onClick={() => onFilterChange("search", "")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </span>
              )}

              {filters.category && (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  Category:{" "}
                  {categories.find((cat) => cat.id === filters.category)
                    ?.name || filters.category}
                  <button
                    type="button"
                    className="ml-1 text-orange-400 hover:text-orange-600"
                    onClick={() => onFilterChange("category", "")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </span>
              )}

              {filters.brand && (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  Brand:{" "}
                  {brands.find((b) => b.id === filters.brand)?.name ||
                    filters.brand}
                  <button
                    type="button"
                    className="ml-1 text-orange-400 hover:text-orange-600"
                    onClick={() => onFilterChange("brand", "")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </span>
              )}

              {filters.stockFilter !== "all" && (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  Stock:{" "}
                  {filters.stockFilter === "in-stock"
                    ? "In Stock"
                    : filters.stockFilter === "low-stock"
                    ? "Low Stock"
                    : "Out of Stock"}
                  <button
                    type="button"
                    className="ml-1 text-orange-400 hover:text-orange-600"
                    onClick={() => onFilterChange("stockFilter", "all")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </span>
              )}
            </div>

            <button
              type="button"
              className="text-sm text-gray-600 hover:text-gray-900"
              onClick={handleClearFilters}
            >
              Clear all filters
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InventoryFilters;